import { render, staticRenderFns } from "./trafficPermit.vue?vue&type=template&id=4e29fd06&"
import script from "./trafficPermit.vue?vue&type=script&lang=js&"
export * from "./trafficPermit.vue?vue&type=script&lang=js&"
import style0 from "./trafficPermit.vue?vue&type=style&index=0&id=4e29fd06&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports